import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sim-and-device-binding-mitigating',
  templateUrl: './sim-and-device-binding-mitigating.component.html',
  styleUrls: ['./sim-and-device-binding-mitigating.component.css']
})
export class SimAndDeviceBindingMitigatingComponent implements OnInit {

  heading = "SIM & Device Binding: Mitigating Identity Theft & Frauds for Banking & Financial Apps";
  subheading = "";
  innerWidth:number = window.innerWidth;

  constructor() { }

  ngOnInit(): void {
  }

  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }

}
